/**
 * @description 发货通知单的订单明细列表
 * @author: 菩萨蛮
 * @date 2020/9/27 5:51 下午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */


const NoticeOrderDetail = {
  warehouseId: { title: '仓库id', disabled: true },
  warehouse: { title: '仓库', type: 'slot', disabled: true  },
  saleOrderNo: { title: '销售订单编号', disabled: true },
  goodsId: { title: '物品id', disabled: true },
  goodsNo: { title: '物品编号', disabled: true, required: true },
  artName: { title: '品名', disabled: true },
  blendName: { title: '成分', disabled: true },
  weight: { title: '克重', type: 'number', disabled: true },
  width: { title: '门幅', type: 'number', disabled: true },
  goodsWeight: { title: '重量', type: 'number', disabled: true },
  saleOrderQuantity: { title: '订单数量', type: 'number', disabled: true },
  // unNoticeCount: { title: '待通知发货数量', type: 'number', disabled: true },
  unitPrice: { title: '单价', type: 'number', disabled: true, required: true },
  noticeMainCount: { title: '本次通知发货数量', type: 'number', disabled: true, required: true },
  noticeMainUnit: { title: '主单位', type: 'slot', disabled: true },
  // noticeSlaveQuantity: { title: '本次通知件数', type: 'number', disabled: true },
  // noticeSlaveUnit: { title: '副单位', type: 'slot', disabled: true },
  batchList: { title: '批次号', type: 'list', disabled: true },
  remark: { title: '备注' }
};

export default NoticeOrderDetail;
